module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ts.worker.9e9116bf83e5f36ed905.js");
}
